const BYTE_UNITS = [
  'byte',
  'kilobyte',
  'megabyte',
  'gigabyte',
  'terabyte',
] as const;

/**
 * Converts a raw byte count into a scaled value and its corresponding
 * Intl.NumberFormat unit name. This is needed because useNumberFormatter
 * with `unit: 'byte'` and `notation: 'compact'` conflates the SI compact
 * suffix ("B" for billion) with the byte unit symbol ("B"), producing
 * labels like "1.5BB" instead of "1.5GB".
 */
export function getByteUnit(bytes: number): {
  value: number;
  unit: (typeof BYTE_UNITS)[number];
} {
  let value = Math.abs(bytes);
  let unitIndex = 0;
  while (value >= 1000 && unitIndex < BYTE_UNITS.length - 1) {
    value /= 1000;
    unitIndex++;
  }
  return {
    value: bytes < 0 ? -value : value,
    unit: BYTE_UNITS[unitIndex],
  };
}
